var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconQuote = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 40,
  height: 28,
  viewBox: "0 0 40 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M40.0005 18.1477L35.4063 22.6059L30.8917 27.1429V18.1477H21.7031V0H40.0005V18.1477ZM18.2974 18.1477L13.7814 22.6059L9.18854 27.1429V18.1477H0V0H18.2974V18.1477Z",
  fill: "#4585FF"
})));
export default SvgIconQuote;